export default {
    //聊天列表滚动
    async pageScrollTo() {
        // document.getElementById("chatMain").scrollIntoView(false);
        // let YAxis = document.getElementsByClassName('chatting-content')[0].clientHeight;
        // let data = await window.scrollTo(0, YAxis -300)
        // return await data;
    },
    //设备宽高
    async getScreenOption() {
        let screenWidth = await screen.availWidth;
        let screenHeigth = await screen.availHeight;
        return {
            screenWidth: screenWidth,
            screenHeigth: screenHeigth
        }
    },
    //滚动顶部
    async scrollTop() {
        window.scrollTo(0, 0);
    },

    async onInputBlur(){
        document.getElementById('inputValue') && document.getElementById('inputValue').focus()
    }
}
